import React, { useEffect, useState } from "react";
import InputTextPatrocinador from "../cadastro/inputtextPatrocinador";
import useApp from "../../hooks/useAppContext";
import { useParams, useNavigate } from "react-router-dom";
import LinhaPatrocinador from "./linhaPatrocinador";
import ModalAdmPatrociandor from "./modalAdmPatrocinador";
import { FaArrowLeft, FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../../services/axios";
import useAuth from "../../hooks/useAuthContext";

const FormPatrocinadores = () => {
  const { usuario } = useAuth()
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    getPatrocinador,
    insertUsuarioAdm,
    atualizaPatrocinadorAdm,
    criarUsuarioPatrocinadorAdm,
  } = useApp();

  const [nomePatrocinador, setNomePatrocinador] = useState("");
  const [email, setEmail] = useState("");
  const [segmento, setSegmento] = useState("");
  const [segmentoOutros, setSegmentoOutros] = useState("");
  const [showSegmentoOutros, setShowSegmentoOutros] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [perfil, setPerfil] = useState("");
  const [idUsuario, setIdUsuario] = useState(false);

  const [preview, setPreview] = useState(null);
  const [logo, setLogo] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [idPlano, setIdPlano] = useState("");
  const [sequencia, setSequencia] = useState("");

  useEffect(() => {
    console.log(usuario);
    if (id && usuario) {
      if (usuario.tipo !== "patrocinador") {
        navigate(`/private/perfil`);
      }
      if(usuario.id_patrocinador !== parseInt(id)){
        navigate(`/private/perfil`);
      }
      carregaPatrocinador();
    }

  }, [usuario]);

  const carregaPatrocinador = async () => {
    let patrocinador = await getPatrocinador(id);
    setNomePatrocinador(patrocinador.patrocinador);
    setEmail(patrocinador.email);
    setParticipantes(patrocinador.usuarios);
    setSegmento(patrocinador.segmento);
    setLogoUrl(patrocinador.logo);
    setPerfil(patrocinador.perfil);
    setIdUsuario(patrocinador.id_usuario);
    const planId =
      patrocinador.id_plano ?? patrocinador.idPlano ?? patrocinador?.plano?.id;
    setIdPlano(planId != null && planId !== "" ? String(planId) : "");
    const seq = patrocinador.sequencia;
    setSequencia(
      seq !== null && seq !== undefined && seq !== "" ? String(seq) : ""
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [showModalEdicao, setShowModalEdicao] = useState(false);
  const [participanteParaEditar, setParticipanteParaEditar] = useState(null);
  const [validacaoSegmento, setValidacaoSegmento] = useState(true);

  const handleSegmento = (e) => {
    if (e === "") {
      setValidacaoSegmento(false);
    } else {
      setValidacaoSegmento(true);
    }
    if (e === "outros") {
      setShowSegmentoOutros(true);
    } else {
      setShowSegmentoOutros(false);
      setSegmentoOutros("");
    }
    setSegmento(e);
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleModalEdicao = () => {
    setShowModalEdicao(!showModalEdicao);
  };

  const abrirModalEdicao = (participante) => {
    setParticipanteParaEditar(participante);
    setShowModalEdicao(true);
  };

  const editarParticipante = async (participanteEditado) => {
    try {
      // Preparar os dados para o endpoint
      const dadosParaEnvio = {
        nome: participanteEditado.nome,
        nome_cracha: participanteEditado.nome_cracha,
        email: participanteEditado.email,
        cpf: participanteEditado.cpf,
        dt_nascimento: participanteEditado.dt_nascimento,
        celular: participanteEditado.celular,
        cargo: participanteEditado.cargo,
        telefone_comercial: participanteEditado.telefone_comercial,
        sexo: participanteEditado.sexo === "Masculino" ? "masculino" : "feminino",
        tipo: participanteEditado.tipo
      };

      // Enviar dados para o endpoint
      const response = await api.put(`/usuarios-update/${participanteEditado.id}`, dadosParaEnvio);

      if (response.status === 200) {
        // Atualizar o estado local
        const participantesAtualizados = participantes.map(p => 
          p.id === participanteEditado.id ? participanteEditado : p
        );
        setParticipantes(participantesAtualizados);
        setShowModalEdicao(false);
        setParticipanteParaEditar(null);
        toast.success("Participante atualizado com sucesso");
      } else {
        toast.error("Erro ao atualizar participante");
      }
    } catch (error) {
      console.error("Erro ao atualizar participante:", error);
      toast.error("Erro ao atualizar participante. Tente novamente.");
    }
  };

  const incluirParticipante = async (participante) => {
    await insertUsuarioAdm(
      participante.nome,
      participante.cpf,
      participante.dt_nascimento,
      participante.email,
      "participante_patrocinador",
      participante.nome_cracha,
      participante.sexo === "Masculino" ? "masculino" : "feminino",
      participante.celular,
      nomePatrocinador,
      participante.cargo,
      participante.telefone_comercial,
      participante.departamento,
      segmento,
      segmentoOutros,
      id
    );
    if (id) {
      carregaPatrocinador();
    }
  };

  const handleChangeImage = (e) => {
    if (e.target.files.length) {
      setPreview(URL.createObjectURL(e.target.files[0]));
      setLogo(e.target.files[0]);
    }
  };

  const salvarPatrocinador = async () => {
    let resp = await atualizaPatrocinadorAdm(
      nomePatrocinador,
      perfil,
      email,
      logo,
      segmento,
      idPlano,
      id ?? null,
      sequencia === "" ? null : Number(sequencia)
    );
    if (id) {
      carregaPatrocinador();
      toast.success("Patrocinador atualizado com sucesso");
    } else {
      navigate(
        "/private/adm/patrocinadores/editar/" + resp.novoPatrocinadorInsert.id
      );
    }
  };

  const criarUser = async () => {
    let response = await criarUsuarioPatrocinadorAdm(id);
    if (response?.mensagem) {
      toast.success("Usuário criado com sucesso");
      if (id) {
        carregaPatrocinador();
      }
    } else {
      toast.error("Erro ao criar usuário");
    }

  };

  return (
    <div className="container-adm-main">
      <div style={{ paddingBottom: "150px" }}>
        <div className="header-tela-adm">
          <h3>{id ? "Editar" : "Novo"} Patrocinador</h3>
          <div className="header-options">
            {id && (
              <>
                <button
                  className="btn btn-header-options"
                  onClick={() => navigate(`/private/adm/patrocinadores/lista-selecao/${id}`)}
                  style={{ marginRight: "10px" }}
                >
                  <FaEye style={{ marginRight: "4px" }} /> Ver Lista de Seleção
                </button>
              </>
            )}
            <button
              className="btn btn-header-options"
              onClick={() => {
                navigate(-1);
              }}
            >
              <FaArrowLeft style={{ marginRight: "4px" }} /> Voltar
            </button>
          </div>
        </div>
        <div className="body-tela-adm">
          <div className="area-imagem-usuario-patrocinador">
            <div className="form-imagem">
              {preview ? (
                <div className="">
                  <img src={preview} alt="" />
                </div>
              ) : (
                <img
                  className=""
                  src={logoUrl}
                  alt=""
                  title="Alterar imagem da empresa"
                />
              )}
              <input
                type="file"
                id="input-perfil-adm"
                onChange={(e) => handleChangeImage(e)}
              />
            </div>
          </div>

          <ModalAdmPatrociandor
            titulo="Inclusão de participante"
            show={showModal}
            toggleModal={() => handleModal()}
            footer={true}
            incluirParticipante={incluirParticipante}
          />

          <ModalAdmPatrociandor
            titulo="Edição de participante"
            show={showModalEdicao}
            toggleModal={() => handleModalEdicao()}
            footer={true}
            incluirParticipante={editarParticipante}
            participanteParaEditar={participanteParaEditar}
            modoEdicao={true}
          />

          <div className="area-inputs">
            <InputTextPatrocinador
              label="Nome da Instituição"
              type="text"
              requered={true}
              value={nomePatrocinador}
              onChange={setNomePatrocinador}
            />

            <InputTextPatrocinador
              label="E-mail Principal"
              type="email"
              requered={true}
              value={email}
              onChange={setEmail}
            />

            <InputTextPatrocinador
              label="Sequência"
              type="number"
              requered={false}
              value={sequencia}
              onChange={setSequencia}
            />

            <label className="form-label" htmlFor="input_perfil" style={{ marginBottom: "0px" }}>
              Perfil <span className="text-red">*</span>
            </label>
            <textarea
              className="form-control form-control-lg"
              rows="5"
              value={perfil}
              onChange={(e) => setPerfil(e.target.value)}
              placeholder="Descreva o perfil da instituição..."
              style={{ marginTop: "0px" }}
            ></textarea>

            <label className="form-label" htmlFor="input_procura" style={{ marginTop: "0px" }}>
              Segmento: <span className="text-red">*</span>
            </label>
            <select
              className={`form-select form-control form-control-lg ${validacaoSegmento ? "" : "requered-error"
                }`}
              aria-label="Default select example"
              id="input_procura"
              value={segmento}
              onChange={(e) => handleSegmento(e.target.value)}
              style={{ marginTop: "0px" }}
            >
              <option value="">Selecione uma opção</option>
              <option value="tecnologia">Tecnologia</option>
              <option value="facilities">Facilities</option>
              <option value="equipamentos">Equipamentos</option>
              <option value="homecare">Home care</option>
              <option value="infraestrutura">Infraestrutura</option>
              <option value="consultoria">Consultoria</option>
              <option value="logistica">Logistica</option>
              <option value="consumiveis">Consumiveis</option>
              <option value="outros">Outros</option>
            </select>

            {showSegmentoOutros ? (
              <InputTextPatrocinador
                label="Descrição do segmento"
                type="text"
                value={segmentoOutros}
                onChange={setSegmentoOutros}
                requered={showSegmentoOutros}
              />
            ) : (
              false
            )}
          </div>
          {id ? (
            <div
              className={`area-participantes-patrocinador ${participantes?.length === 0 ? "requered-error" : ""
                }`}
            >
              <div className="header-participantes-patrocinadores">
                <div>
                  <h5>Executivos </h5>
                </div>
                <div>
                  <button
                    style={{ backgroundColor: "#008A38" }}
                    type="button"
                    className="text-white btn botoes-cadastro-alterar-senha"
                    onClick={() => {
                      handleModal();
                    }}
                  >
                    Incluir
                  </button>
                </div>
              </div>
              <div className="body-participantes-patrocinador">
                <div className="linha-participantes-header" style={{ textAlign: "center" }}>
                  <div>Nome Completo</div>
                  <div>Nome Crachá</div>
                  <div>E-mail</div>
                  <div>Opções</div>
                </div>
                {participantes
                  ? participantes?.map((p) => {
                    if(p.tipo === "recepcao"){
                      return false;
                    }
                    return <LinhaPatrocinador 
                      key={p.id}
                      participante={p} 
                      onEditar={abrirModalEdicao}
                    />;
                  })
                  : "Nenhum participante incluido"}
              </div>
            </div>
          ) : (
            false
          )}
          <div className="area-botoes-patrocinador">
            {id && !idUsuario ? (
              <button
                style={{ backgroundColor: "#008A38" }}
                type="button"
                className="text-white btn botoes-cadastro-alterar-senha"
                onClick={() => {
                  criarUser();
                }}
              >
                Criar Usuário
              </button>
            ) : (
              false
            )}
            <button
              style={{ backgroundColor: "#008A38" }}
              type="button"
              className="text-white btn botoes-cadastro-alterar-senha"
              onClick={() => {
                salvarPatrocinador();
              }}
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FormPatrocinadores;
